import React, { PureComponent } from "react";

import Select from "react-select";

import { Accordion, Button, ButtonGroup, Dropdown, Icon } from "aible";

import styles from "./style.module.css";

export default class ProjectHelpItem extends React.PureComponent {
  render() {
    const { type, src, isDark, children, className, ...retProps } = this.props;
    return (
      <div className={styles.projectHelpItemWrapper}>
        <div className={styles.projectHelpItemIcon + " " + (isDark ? styles.isDark : "")}>
          <Icon type={type} src={src} />
        </div>
        <div className={styles.projectHelpItemText + " " + (isDark ? styles.isDark : "")}>{children}</div>
      </div>
    );
  }
}
